
import {of as observableOf, Observable} from 'rxjs';

import {catchError} from 'rxjs/operators';
import { AppPermissionsService } from './../../services/app-permissions/app-permissions.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class EcaIsAdministratorGuard  {
  private _appPermissionsService = inject(AppPermissionsService);
  private _router = inject(Router);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._appPermissionsService.controlTruthyObservable(
      this._appPermissionsService.isAdministrator()
    ).pipe(
      catchError(() => {
        this._router.navigateByUrl('/denied');
        return observableOf(false);
      }));
  }
}
